import abeagle from './abeagle';

const testSlug = 'hp_sticky_video_desktop';
const {
  edition,
  device,
  isEntry,
  isFront,
} = window.HP.params;

// we want to run this test on US edition homepage and article pages only
// and only on desktop devices
if (
  edition === 'us'
  && device === 'desktop'
  && (isEntry || isFront)
  && window.HP.params.abeagle
  && Array.isArray(window.HP.params.abeagle)
  && window.HP.params.abeagle.includes(testSlug)
) {
  document.addEventListener('abeagleEventCambria', () => {
    const variant = abeagle.getExperimentVariant(testSlug);
    window.HP.params.abStickyVideoDesktopTest.variant = variant;
  });
  window.HP.params.abStickyVideoDesktopTest.ready = true;
}
